import React from "react";

interface LogoProps {
  size?: "sm" | "md" | "lg";
  variant?: "full" | "icon" | "text" | "combo";
  colorScheme?: "light" | "dark" | "color";
}

/** 4KMatch brand logo with icon, text, and combo variants. */
export const Logo: React.FC<LogoProps> = ({
  size = "md",
  variant = "combo",
  colorScheme = "light",
}) => {
  const sizes = {
    sm: {
      icon: 28,
      textHeight: 14,
      gap: 0,
    },
    md: {
      icon: 36,
      textHeight: 22,
      gap: 0,
    },
    lg: {
      icon: 48,
      textHeight: 26,
      gap: 0,
    },
  };

  const currentSize = sizes[size];

  // Map color scheme to file suffix
  const colorSuffix =
    colorScheme === "light"
      ? "light"
      : colorScheme === "dark"
      ? "dark"
      : "color";
  const textSuffix =
    colorScheme === "light"
      ? "light"
      : colorScheme === "dark"
      ? "dark"
      : "color";

  // Logo paths
  const logoIconPath = `/images/logo_${colorSuffix}.png`;
  const logoWithTextPath = `/images/logo_text_${textSuffix}.png`;
  const logoTextOnlyPath = `/images/logo_text_only_${textSuffix}.png`;

  if (variant === "icon") {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
        }}
      >
        <img
          src={logoIconPath}
          alt="4KMatch"
          style={{
            height: `${currentSize.icon}px`,
            width: "auto",
            objectFit: "contain",
          }}
        />
      </div>
    );
  }

  if (variant === "text") {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
        }}
      >
        <img
          src={logoTextOnlyPath}
          alt="4KMatch"
          style={{
            height: `${currentSize.textHeight}px`,
            width: "auto",
            objectFit: "contain",
          }}
        />
      </div>
    );
  }

  if (variant === "full") {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
        }}
      >
        <img
          src={logoWithTextPath}
          alt="4KMatch"
          style={{
            height: `${currentSize.icon + 8}px`,
            width: "auto",
            objectFit: "contain",
          }}
        />
      </div>
    );
  }

  // Default: combo (icon + text side by side - both same height)
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: `${currentSize.gap}px`,
      }}
    >
      <img
        src={logoIconPath}
        alt=""
        style={{
          height: `${currentSize.textHeight}px`,
          width: "auto",
          objectFit: "contain",
        }}
      />
      <img
        src={logoTextOnlyPath}
        alt="4KMatch"
        style={{
          height: `${currentSize.textHeight}px`,
          width: "auto",
          objectFit: "contain",
        }}
      />
    </div>
  );
};

export default Logo;
